import { UndoOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";

const RestoreButton = ({
  label,
  loading,
  type = BUTTON_TYPE.DEFAULT,
  onClick,
  buttonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Button
      icon={<UndoOutlined />}
      key={BUTTON_KEYS.RESTORE}
      loading={loading}
      role="button"
      size="small"
      type={type}
      onClick={onClick}
      {...buttonProps}
    >
      {label ?? t("global:restore")}
    </Button>
  );
};

export default RestoreButton;
